import React, { useState } from "react";
import CustomSelection from "../CustomSelection/CustomSelection";
import search from "../assets/search.png";
import ViewFilter from "../ViewFilter/ViewFilter";

const FilterRowSection = ({NoOfListedItems}) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };
  const handleOptionSelect2 = (option) => {
    setSelectedOption2(option);
  };
  const options = ["filter", "filter 2", "filter 3"];
  const options2 = ["low to high", "high to low"];

  return (
    <div className="flex w-full flex-col  items-center lg:items-start gap-4 xl:gap-0 xl:flex-row">
      <div className="mr-[20px] 3xl:mr-[135px] ">
        <h2 className="text-normal font-bold md:leading-[44px] 2xl:text-[36px] whitespace-nowrap">
          {NoOfListedItems} Items
        </h2>
      </div>
      <div className="flex grow justify-center flex-wrap gap-[20px] gap-y-[20px] 2xl:gap-x-0">
        <div className="order-2 xl:order-1 ">
          <CustomSelection
            options={options}
            defaultValue={"filter"}
            onSelect={handleOptionSelect}
          ></CustomSelection>
        </div>

        <div className="flex h-[44px] grow items-center rounded-[12px] bg-main-black  pl-[32px] 2xl:ml-[33px] order-1 xl:order-2">
          <img src={search} alt="" />
          <input
            type="text"
            className="text-res-xxs h-full w-full rounded-[12px] bg-main-black pl-[16px] placeholder:text-[#8A8AA0] focus:border-none focus:outline-none active:border-none"
            placeholder="Type to search"
          />
        </div>
        {/* <div className="2xl:pl-[39px] order-2 xl:order-3">
          <ViewFilter></ViewFilter>
        </div> */}
        <div className=" 2xl:pl-[45px] order-3 xl:order-4">
          <CustomSelection
            options={options2}
            defaultValue={"low to high"}
            onSelect={handleOptionSelect2}
          ></CustomSelection>
        </div>
      </div>
    </div>
  );
};

export default FilterRowSection;
